// Mellow Sleep — shared vanilla JS for mt- sections

function mtInitReveal() {
  var els = document.querySelectorAll('.mt-reveal:not(.mt-visible)');
  if (!els.length) return;

  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
  );

  els.forEach(function (el) { observer.observe(el); });
}

function mtInitParallax() {
  var layers = document.querySelectorAll('[data-mt-parallax]');
  if (!layers.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var ticking = false;

  function update() {
    var winH = window.innerHeight;
    layers.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      var speed = parseFloat(el.dataset.mtParallax) || 0.15;
      var center = rect.top + rect.height / 2 - winH / 2;
      el.style.transform = 'translateY(' + (center * speed * -1) + 'px)';
    });
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    },
    { passive: true }
  );
  update();
}

function mtInitTilt() {
  var cards = document.querySelectorAll('.mt-tilt');
  if (!cards.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia('(hover: none)').matches) return;

  cards.forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var rect = card.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      card.style.transform = 'perspective(800px) rotateY(' + (x * 6) + 'deg) rotateX(' + (y * -6) + 'deg)';
    });
    card.addEventListener('mouseleave', function () {
      card.style.transform = 'perspective(800px) rotateY(0deg) rotateX(0deg)';
    });
  });
}

function mtInitVariantPicker() {
  var forms = document.querySelectorAll('.mt-variant-form');
  if (!forms.length) return;

  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-mt-variants-json]');
    if (!dataEl) return;
    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var idInput = form.querySelector('input[name="id"]');
    var priceEl = form.querySelector('[data-mt-price]');
    var compareEl = form.querySelector('[data-mt-compare-price]');
    var submitBtn = form.querySelector('[data-mt-submit]');
    var optionInputs = form.querySelectorAll('[data-mt-option]');
    var gallery = form.closest('.mt-producto__grid') ? form.closest('.mt-producto__grid').querySelector('[data-mt-gallery]') : null;
    var galleryMain = gallery ? gallery.querySelector('[data-mt-gallery-main]') : null;

    function currentSelection() {
      var selection = [];
      optionInputs.forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) selection.push(checked.value);
      });
      return selection;
    }

    function findVariant(selection) {
      return variants.find(function (v) {
        return v.options.length === selection.length && v.options.every(function (val, i) { return val === selection[i]; });
      });
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function updateUI() {
      var selection = currentSelection();
      var variant = findVariant(selection);
      if (!variant) return;

      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (submitBtn) {
        if (variant.available) {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.dataset.addText || submitBtn.textContent;
        } else {
          submitBtn.disabled = true;
          submitBtn.textContent = submitBtn.dataset.soldOutText || 'Agotado';
        }
      }
      if (variant.featured_image && galleryMain) {
        galleryMain.src = variant.featured_image;
      }
    }

    optionInputs.forEach(function (group) {
      var isColor = group.hasAttribute('data-mt-option-color');
      group.addEventListener('change', function (e) {
        updateUI();
        if (isColor) {
          var checked = group.querySelector('input:checked');
          group.querySelectorAll('.mt-swatch').forEach(function (sw) { sw.classList.remove('mt-swatch--activo'); });
          if (checked) {
            var swatch = checked.parentElement.querySelector('.mt-swatch');
            if (swatch) swatch.classList.add('mt-swatch--activo');
            var label = form.querySelector('[data-mt-option-selected]');
            if (label) label.textContent = checked.dataset.mtOptionLabel || checked.value;
          }
        }
      });
    });

    updateUI();
  });
}

function mtInitGallery() {
  var galleries = document.querySelectorAll('[data-mt-gallery]');
  galleries.forEach(function (gallery) {
    var main = gallery.querySelector('[data-mt-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-mt-gallery-thumb]');
    if (!main || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.dataset.mtGalleryThumb;
        main.src = full;
        thumbs.forEach(function (t) { t.classList.remove('mt-thumb--active'); });
        thumb.classList.add('mt-thumb--active');
      });
    });
  });
}

function mtInitCountUp() {
  var els = document.querySelectorAll('[data-mt-countup]');
  if (!els.length) return;

  function animate(el) {
    var target = parseFloat(el.dataset.mtTarget) || 0;
    var suffix = el.dataset.mtSuffix || '';
    var isDecimal = target % 1 !== 0;
    var duration = 1400;
    var start = null;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.textContent = (isDecimal ? target.toFixed(1) : target) + suffix;
      return;
    }

    function step(ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var value = target * eased;
      el.textContent = (isDecimal ? value.toFixed(1) : Math.round(value)) + suffix;
      if (progress < 1) window.requestAnimationFrame(step);
    }
    window.requestAnimationFrame(step);
  }

  if (!('IntersectionObserver' in window)) {
    els.forEach(animate);
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animate(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.5 }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function mtInitBundle() {
  var bundles = document.querySelectorAll('[data-mt-bundle]');
  bundles.forEach(function (bundle) {
    var checkboxes = bundle.querySelectorAll('[data-mt-bundle-item]');
    var totalEl = bundle.querySelector('[data-mt-bundle-total]');
    var addBtn = bundle.querySelector('[data-mt-bundle-add]');

    function updateTotal() {
      var total = 0;
      checkboxes.forEach(function (cb) {
        if (cb.checked) total += parseFloat(cb.dataset.mtBundleItem) || 0;
      });
      if (totalEl) totalEl.textContent = '$' + total.toFixed(2);
    }

    checkboxes.forEach(function (cb) {
      cb.addEventListener('change', updateTotal);
    });
    updateTotal();

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var items = [];
        checkboxes.forEach(function (cb) {
          if (cb.checked) {
            items.push({ id: parseInt(cb.dataset.mtBundleVariant, 10), quantity: 1 });
          }
        });
        if (!items.length) return;

        addBtn.disabled = true;
        var originalText = addBtn.textContent;
        addBtn.textContent = 'Adding...';

        fetch(window.Shopify && window.routes ? window.routes.cart_add_url : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items }),
        })
          .then(function (res) { return res.json(); })
          .then(function () {
            addBtn.textContent = 'Added ✓';
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            window.location.href = window.routes ? window.routes.cart_url : '/cart';
          })
          .catch(function () {
            addBtn.textContent = originalText;
            addBtn.disabled = false;
          });
      });
    }
  });
}

function mtInitOferta() {
  var forms = document.querySelectorAll('.mt-variant-form');
  forms.forEach(function (form) {
    var idInput = form.querySelector('input[name="id"]');
    var submitBtn = form.querySelector('[data-mt-submit]');
    if (!idInput || !submitBtn) return;

    var tierWrap = form.querySelector('[data-mt-oferta]');
    var tiers = tierWrap ? tierWrap.querySelectorAll('[data-mt-tier]') : [];
    var giftInput = form.querySelector('[data-mt-gift-variant]');
    var giftVariantId = giftInput ? giftInput.value : null;
    var gift2Input = form.querySelector('[data-mt-gift2-variant]');
    var gift2VariantId = gift2Input ? gift2Input.value : null;
    var unitColorPanels = tierWrap ? tierWrap.querySelectorAll('[data-mt-unit-colors]') : [];
    var giftPickerPanels = tierWrap ? tierWrap.querySelectorAll('[data-mt-gift-picker]') : [];

    var gift1VariantsEl = form.querySelector('[data-mt-gift1-variants-json]');
    var gift1Variants = [];
    if (gift1VariantsEl) {
      try { gift1Variants = JSON.parse(gift1VariantsEl.textContent); } catch (e) { gift1Variants = []; }
    }
    var gift2VariantsEl = form.querySelector('[data-mt-gift2-variants-json]');
    var gift2Variants = [];
    if (gift2VariantsEl) {
      try { gift2Variants = JSON.parse(gift2VariantsEl.textContent); } catch (e) { gift2Variants = []; }
    }
    var gift1DefaultOptionsInput = form.querySelector('[data-mt-gift1-default-options]');
    var gift1DefaultOptions = [];
    if (gift1DefaultOptionsInput) {
      try { gift1DefaultOptions = JSON.parse(gift1DefaultOptionsInput.value); } catch (e) { gift1DefaultOptions = []; }
    }
    var gift2DefaultOptionsInput = form.querySelector('[data-mt-gift2-default-options]');
    var gift2DefaultOptions = [];
    if (gift2DefaultOptionsInput) {
      try { gift2DefaultOptions = JSON.parse(gift2DefaultOptionsInput.value); } catch (e) { gift2DefaultOptions = []; }
    }

    var variantsDataEl = form.querySelector('[data-mt-variants-json]');
    var variants = [];
    if (variantsDataEl) {
      try { variants = JSON.parse(variantsDataEl.textContent); } catch (e) { variants = []; }
    }
    var mainOptionGroups = form.querySelectorAll('[data-mt-option]');

    function baseSelection() {
      var selection = [];
      mainOptionGroups.forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) selection.push(checked.value);
      });
      return selection;
    }

    function findVariant(selection) {
      return variants.find(function (v) {
        return v.options.length === selection.length && v.options.every(function (val, i) { return val === selection[i]; });
      });
    }

    function updateActiveTier() {
      var activeValue = null;
      tiers.forEach(function (tier) {
        var radio = tier.querySelector('input[type="radio"]');
        var isActive = !!(radio && radio.checked);
        tier.classList.toggle('mt-oferta__tier--activa', isActive);
        if (isActive && radio) activeValue = radio.value;
      });
      unitColorPanels.forEach(function (panel) {
        panel.hidden = panel.dataset.mtTierValue !== activeValue;
      });
      giftPickerPanels.forEach(function (panel) {
        panel.hidden = panel.dataset.mtTierValue !== activeValue;
      });
    }

    tiers.forEach(function (tier) {
      var radio = tier.querySelector('input[type="radio"]');
      if (radio) radio.addEventListener('change', updateActiveTier);
    });

    unitColorPanels.forEach(function (panel) {
      panel.querySelectorAll('.mt-oferta__unit-option').forEach(function (optionWrap) {
        var radios = optionWrap.querySelectorAll('input[type="radio"]');
        radios.forEach(function (radio) {
          radio.addEventListener('change', function () {
            optionWrap.querySelectorAll('.mt-swatch, .mt-pill-small').forEach(function (el) {
              el.classList.remove('mt-swatch--activo', 'mt-pill-small--activo');
            });
            var swatch = radio.parentElement.querySelector('.mt-swatch');
            if (swatch) swatch.classList.add('mt-swatch--activo');
            var pill = radio.parentElement.querySelector('.mt-pill-small');
            if (pill) pill.classList.add('mt-pill-small--activo');
          });
        });
      });
    });

    giftPickerPanels.forEach(function (panel) {
      panel.querySelectorAll('[data-mt-gift-option]').forEach(function (wrap) {
        var radios = wrap.querySelectorAll('input[type="radio"]');
        radios.forEach(function (radio) {
          radio.addEventListener('change', function () {
            wrap.querySelectorAll('.mt-swatch, .mt-pill-small').forEach(function (el) {
              el.classList.remove('mt-swatch--activo', 'mt-pill-small--activo');
            });
            var swatch = radio.parentElement.querySelector('.mt-swatch');
            if (swatch) swatch.classList.add('mt-swatch--activo');
            var pill = radio.parentElement.querySelector('.mt-pill-small');
            if (pill) pill.classList.add('mt-pill-small--activo');
          });
        });
      });
    });

    function resolveGiftVariant(role, variants, defaultOptions, panel) {
      if (!panel || !variants.length || !defaultOptions.length) return null;
      var selection = defaultOptions.slice();
      var found = false;
      panel.querySelectorAll('[data-mt-gift-role="' + role + '"] input:checked').forEach(function (radio) {
        var pos = parseInt(radio.dataset.mtGiftOptionPosition, 10) - 1;
        selection[pos] = radio.value;
        found = true;
      });
      if (!found) return null;
      return findGiftVariant(variants, selection);
    }

    function findGiftVariant(list, selection) {
      return list.find(function (v) {
        return v.options.length === selection.length && v.options.every(function (val, i) { return val === selection[i]; });
      });
    }

    updateActiveTier();

    submitBtn.addEventListener('click', function () {
      if (submitBtn.disabled) return;

      var qty = 1;
      var gift1Qty = 0;
      var gift2Qty = 0;
      var activeTierValue = null;
      if (tierWrap) {
        var checked = tierWrap.querySelector('input[name="mt-oferta-tier"]:checked');
        if (checked) {
          qty = parseInt(checked.dataset.mtQty, 10) || 1;
          gift1Qty = parseInt(checked.dataset.mtGift1Qty, 10) || 0;
          gift2Qty = parseInt(checked.dataset.mtGift2Qty, 10) || 0;
          activeTierValue = checked.value;
        }
      }

      var items = [];
      var activePanel = null;
      unitColorPanels.forEach(function (panel) {
        if (panel.dataset.mtTierValue === activeTierValue && !panel.hidden) activePanel = panel;
      });

      if (activePanel && variants.length) {
        var base = baseSelection();
        var counts = {};
        var rows = activePanel.querySelectorAll('.mt-oferta__unit-row');
        rows.forEach(function (row) {
          var selection = base.slice();
          var checkedInRow = row.querySelectorAll('input[type="radio"]:checked');
          checkedInRow.forEach(function (radio) {
            var pos = parseInt(radio.dataset.mtUnitOptionPosition, 10) - 1;
            selection[pos] = radio.value;
          });
          var variant = findVariant(selection);
          var vId = variant ? variant.id : parseInt(idInput.value, 10);
          counts[vId] = (counts[vId] || 0) + 1;
        });
        Object.keys(counts).forEach(function (vId) {
          items.push({ id: parseInt(vId, 10), quantity: counts[vId] });
        });
      } else {
        items.push({ id: parseInt(idInput.value, 10), quantity: qty });
      }

      var activeGiftPanel = null;
      giftPickerPanels.forEach(function (panel) {
        if (panel.dataset.mtTierValue === activeTierValue && !panel.hidden) activeGiftPanel = panel;
      });

      var finalGift1Id = giftVariantId;
      var finalGift2Id = gift2VariantId;

      if (activeGiftPanel) {
        var gift1Match = resolveGiftVariant('gift1', gift1Variants, gift1DefaultOptions, activeGiftPanel);
        if (gift1Match) finalGift1Id = gift1Match.id;
        var gift2Match = resolveGiftVariant('gift2', gift2Variants, gift2DefaultOptions, activeGiftPanel);
        if (gift2Match) finalGift2Id = gift2Match.id;
      }

      if (gift1Qty > 0 && finalGift1Id) {
        items.push({ id: parseInt(finalGift1Id, 10), quantity: gift1Qty, properties: { _mt_regalo: 'gift1' } });
      }
      if (gift2Qty > 0 && finalGift2Id) {
        items.push({ id: parseInt(finalGift2Id, 10), quantity: gift2Qty, properties: { _mt_regalo: 'gift2' } });
      }

      var originalText = submitBtn.textContent;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding...';

      fetch(window.routes ? window.routes.cart_add_url : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data && data.status) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
            alert(data.description || 'Something went wrong. Please try again.');
            return;
          }
          submitBtn.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          window.location.href = window.routes ? window.routes.cart_url : '/cart';
        })
        .catch(function () {
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        });
    });
  });
}

function mtInitComparar() {
  var sliders = document.querySelectorAll('[data-mt-compare]');
  sliders.forEach(function (slider) {
    var before = slider.querySelector('[data-mt-compare-before]');
    var handle = slider.querySelector('[data-mt-compare-handle]');
    if (!before || !handle) return;
    var dragging = false;

    function setPercent(percent) {
      percent = Math.max(0, Math.min(100, percent));
      before.style.clipPath = 'inset(0 ' + (100 - percent) + '% 0 0)';
      handle.style.left = percent + '%';
    }

    function percentFromEvent(e) {
      var rect = slider.getBoundingClientRect();
      var x = e.clientX - rect.left;
      return (x / rect.width) * 100;
    }

    slider.addEventListener('pointerdown', function (e) {
      dragging = true;
      setPercent(percentFromEvent(e));
    });
    window.addEventListener('pointermove', function (e) {
      if (dragging) setPercent(percentFromEvent(e));
    });
    window.addEventListener('pointerup', function () {
      dragging = false;
    });

    setPercent(50);
  });
}

function mtInitRotatingText() {
  var containers = document.querySelectorAll('[data-mt-rotating-text]');
  containers.forEach(function (container) {
    var wordEl = container.querySelector('[data-mt-rotate-word]');
    var dataEl = container.querySelector('[data-mt-rotate-words]');
    if (!wordEl || !dataEl) return;

    var words;
    try {
      words = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!words || words.length < 2) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var index = 0;
    setInterval(function () {
      index = (index + 1) % words.length;
      wordEl.style.opacity = '0';
      wordEl.style.transform = 'translateY(8px)';
      setTimeout(function () {
        wordEl.textContent = words[index];
        wordEl.style.opacity = '1';
        wordEl.style.transform = 'translateY(0)';
      }, 300);
    }, 2600);
  });
}

function mtInitCountdown() {
  var boxes = document.querySelectorAll('[data-mt-countdown]');
  if (!boxes.length) return;

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  var CYCLE_MS = 3 * 24 * 60 * 60 * 1000;

  function tick() {
    var diff = CYCLE_MS - (Date.now() % CYCLE_MS);

    var hours = Math.floor(diff / 3600000);
    var minutes = Math.floor((diff % 3600000) / 60000);
    var seconds = Math.floor((diff % 60000) / 1000);

    boxes.forEach(function (box) {
      var h = box.querySelector('[data-mt-countdown-hours]');
      var m = box.querySelector('[data-mt-countdown-minutes]');
      var s = box.querySelector('[data-mt-countdown-seconds]');
      if (h) h.textContent = pad(hours);
      if (m) m.textContent = pad(minutes);
      if (s) s.textContent = pad(seconds);
    });
  }

  tick();
  setInterval(tick, 1000);
}

function mtInitVariantesSwatches() {
  var rows = document.querySelectorAll('[data-mt-variantes-swatches]');
  rows.forEach(function (row) {
    var wrap = row.closest('.mt-variantes__grid') || row.closest('.mt-variantes');
    var img = wrap ? wrap.querySelector('[data-mt-variantes-img]') : null;
    if (!img) return;
    var swatches = row.querySelectorAll('[data-mt-variant-swatch]');
    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var newSrc = swatch.getAttribute('data-image');
        if (!newSrc) return;
        img.src = newSrc;
        img.alt = swatch.getAttribute('data-alt') || '';
        swatches.forEach(function (s) {
          s.classList.remove('mt-swatch--activo');
        });
        swatch.classList.add('mt-swatch--activo');
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  mtInitReveal();
  mtInitParallax();
  mtInitTilt();
  mtInitVariantPicker();
  mtInitGallery();
  mtInitCountUp();
  mtInitBundle();
  mtInitOferta();
  mtInitComparar();
  mtInitRotatingText();
  mtInitVariantesSwatches();
  mtInitCountdown();
});
